module.exports = __webpack_public_path__ + "static/media/SelectedLaayer.ae3ad685.svg";